 jQuery.fn.quickOuterWidth = function() {
   var elem = this.get(0);
   //console.time("quickOuterWidth");
   if (window.getComputedStyle) {
   	//console.time("getComputedStyle");
    var computedStyle = window.getComputedStyle(elem, null);
     //console.timeEnd("getComputedStyle");
    var ret = elem.offsetWidth + (parseInt(computedStyle.getPropertyValue('margin-left'), 10) || 0) + (parseInt(computedStyle.getPropertyValue('margin-right'), 10) || 0);
   } else {
    var ret = elem.offsetWidth + (parseInt(elem.currentStyle["marginLeft"]) || 0) + (parseInt(elem.currentStyle["marginRight"]) || 0);
   }
   //console.timeEnd("quickOuterWidth");

   return ret;
  };